














































import {Component, Prop, Vue} from 'vue-property-decorator';
import {CartStore, ICartItemOption, ICartMergedItem, ICartMergedItemOption} from '@/store/modules/cart.store';
import {TicketStore} from '@/store/modules/ticket.store';
import {BadgeStore} from '@/store/modules/badge.store';
import TPWebClientInternalHelpers, {ISlimSelectedOption} from '@/TPWebClientInternal/helpers';
import {WebService} from '@/services/web.service';
import {OverlayShowTime} from '@/constants';
// @ is an alias to /src

@Component({
	components: {
	}
})
export default class ViewCart extends Vue {
	@Prop({required: true})
	ticketId!: string;

	@Prop({required: true})
	menuId!: string;

	showItemOptions = false;
	selectedItemId = '';
	selectedCartItemId = '';

	showLoading = false;

	showOverlay = false;
	overlayMessage = '';

	get cartName() {
		if(this.ticket !== null) {
			if(this.ticket.badgeId === null || this.badge === null) {
				return 'Ticket ' + this.ticketId;
			} else {
				return 'Table ' + this.badge.name;
			}
		}
		return '';
	}

	get ticket() {
		return TicketStore.byId(this.ticketId);
	}

	get badge() {
		if(this.ticket !== null && this.ticket.badgeId !== null) {
			return BadgeStore.byId(this.ticket.badgeId);
		}
		return null;
	}

	get items() {
		return CartStore.mergedItemsByTicket(this.ticketId);
	}

	close() {
		this.$emit('close');
	}

	async deleteItem(cartItemId: string) {
		if(await this.$bvModal.msgBoxConfirm('Are you sure you want to remove this item?', {
			centered: true,
			okTitle: 'Remove Item'
		})) {
			CartStore.removeItem(cartItemId);
		}
	}

	optionsText(options: ICartMergedItemOption[]) {
		return options.map((option) => {
			return option.choices.map((choice) => {
				return choice.name;
			}).join(', ');
		}).join(', ');
	}

	itemPrice(item: ICartMergedItem) {
		return TPWebClientInternalHelpers.calculatePrice(item, item.options, item.options) * item.quantity;
	}

	get totalCost() {
		return this.items.reduce((total, item) => {
			total += this.itemPrice(item);
			return total;
		}, 0);
	}

	editItem(item: ICartMergedItem) {
		this.selectedItemId = item.itemId;
		this.selectedCartItemId = item.cartItemId as string;
		this.showItemOptions = true;
	}

	async orderItems() {
		try {
			this.$emit('beforeUpdate');
			this.showLoading = true;
			await WebService.addLineItem(this.ticketId, this.menuId, this.items.map((item) => {
				return {
					itemId: item.itemId,
					quantity: item.quantity,
					courseId: item.courseId,
					comments: item.specialRequests,
					options: item.options.map((option) => {
						return {
							optionId: option.optionId,
							choices: option.choices.map((choice) => {
								return {
									choiceId: choice.choiceId,
									quantity: 1
								};
							})
						};
					})
				};
			}));
			this.showLoading = false;
			this.$emit('afterUpdate');
			CartStore.clearCart(this.ticketId);
			this.overlayMessage = `Items added`;
			this.showOverlay = true;
			setTimeout(() => {
				this.showOverlay = false;
				this.$emit('closeAll');
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem removing your item', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}


	}
}
